;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    iconFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockCarouselShowcaseWithCard from './BlockCarouselShowcaseWithCard';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    ${iconFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockCarouselShowcaseWithCard(preview: $preview, id: $id) {
            __typename
            anchorId
            title
            slidesCollection(limit: 10) {
                items {
                    __typename
                    ... on CarouselShowcaseWithCardSlide {
                        icon {
                            ... on Icon {
                                ...Icon
                            }
                        }
                        image {
                            ...Asset
                        }
                        imageLarge {
                            ...Asset
                        }
                        eyebrow
                        headline {
                            json
                        }
                        bodyCopy {
                            json
                        }
                        cta {
                            ... on Cta {
                                ...CTA
                            }
                        }
                    }
                }
            }
            cardsPosition
            navTheme
            flushTop
            flushBottom
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockCarouselShowcaseWithCard },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockCarouselShowcaseWithCard;
}

const BlockCarouselShowcaseWithCardServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return (
        <BlockCarouselShowcaseWithCard
            {...block}
            slides={block.slidesCollection.items}
        />
    );
};

export default BlockCarouselShowcaseWithCardServer;
